import type { RouteObject } from 'react-router-dom'

import { Component as PrivacyPolicy } from '@/modules/page/pages/PrivacyPolicy'
import { Component as TermsConditions } from '@/modules/page/pages/TermsConditions'
import { PageRoutePathsEnum } from '@/modules/page/routes/pageRouteConfig.types'

export const PAGES_ROUTES: RouteObject[] = [
  {
    element: <PrivacyPolicy />,
    path: PageRoutePathsEnum.PRIVACY_POLICY,
  },
  {
    element: <TermsConditions />,
    path: PageRoutePathsEnum.TERMS_CONDITIONS,
  },
]
